import classNames from 'classnames/bind';
import config from 'config/index';
import styles from './index.module.scss';
import { areaCode } from './utils';

const cx = classNames.bind(styles);

interface DescriptionMyProps {
  active?: boolean;
  otaName: string;
}

const descriptionMy = ({ active = false, otaName }: DescriptionMyProps) => {
  return (
    <div className={cx('descriptionMy')}>
      {active ? (
        <p className={cx('txt')}>
          네이버 항공권을 통해 예약한 정보는{' '}
          <a
            className={cx('anchor')}
            href={`${config.travelMy}/bookings/flights`}
            data-event-nlog="click"
            data-event-area-code={`${areaCode}.mypage`}
            target="_blank"
          >
            항공권 MY
          </a>
          에서 쉽게 확인할 수 있으며, 이와 같이 네이버{' '}
          <a
            className={cx('anchor')}
            href={`${config.travelMy}/bookings/flights`}
            data-event-nlog="click"
            data-event-area-code={`${areaCode}.mypage`}
            target="_blank"
          >
            항공권 MY
          </a>
          에서 예약정보 조회가 가능한 경우 네이버 여행에서 제공하는 할인/적립
          혜택을 이용하실 수 있습니다.
        </p>
      ) : (
        <p className={cx('txt')}>
          {otaName}은/는 네이버 항공권을 통한 예약정보 확인 기능을 제공하지
          않으며, 이에 따라 {otaName} 제공 항공권 상품에 대해서는 네이버
          여행에서 제공하는 할인/적립 혜택을 이용하실 수 없는 점 유의 바랍니다.
        </p>
      )}
    </div>
  );
};

export default descriptionMy;
